import { render, staticRenderFns } from "./fileShow.vue?vue&type=template&id=495815d5&scoped=true"
import script from "./fileShow.vue?vue&type=script&lang=js"
export * from "./fileShow.vue?vue&type=script&lang=js"
import style0 from "./fileShow.vue?vue&type=style&index=0&id=495815d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495815d5",
  null
  
)

export default component.exports